import React from "react";
import { useDispatch } from "react-redux";
import { Modal } from "semantic-ui-react";
import { closeModal } from "../actions";
import UserForm from "../admin/user-form";

const UserModal = (props) => {
  const dispatch = useDispatch();

  const { userRecord } = props;

  const clear = () => {
    dispatch(closeModal());
  };

  return (
    <Modal
      closeIcon="close"
      open={true}
      onClose={() => clear()}
      centered={props.centered}
    >
      <Modal.Content>
        <UserForm userRecord={userRecord} />
      </Modal.Content>
    </Modal>
  );
};

export default UserModal;
